import Item from './Item/Routes';
import Store from './Store/Routes';


export default [...Item, ...Store];